import React, { useMemo } from 'react'
import creditStatusMapping from '../../RMA/Mapping/creditStatusMapping'
import returnRequestStatusMapping from "../../RMA/Mapping/returnRequestStatusMapping";
import { ReturnStatusBox, MainReasonText, SubReasonText } from './style/ReturnInfoWMO.css'

export default function ReturnInfoWMO({
  orderDetails,
  creditStatus,
  returnRequestStatus,
}) {
  const {
    item,
  } = orderDetails

  let messageData = creditStatusMapping(item.credit.statusCode, creditStatus)

  if (!item.credit.statusCode && item.returnRequestStatus) {
    messageData = returnRequestStatusMapping(item.returnRequestStatus, returnRequestStatus)
  }

  const determineSubReason = useMemo(() => {
    const { shipping, credit } = item
    if (credit.statusCode === '3005') {
      if (shipping && shipping.label) {
        return messageData.sub_reason.shipping_label
      }
      return messageData.sub_reason.no_shipping_label
    }
    return messageData && messageData.sub_reason
  }, [item])

  return (
    <ReturnStatusBox>
      <MainReasonText>
        {messageData && messageData.main_reason }
      </MainReasonText>
      <SubReasonText>
        {determineSubReason}
      </SubReasonText>
    </ReturnStatusBox>
  )
}
